<div [class]="skinName">
  <!--navbar starts-->
  @if (guest) {
    <nav class="navbar navbar-expand-lg">
      <div class="nav-row">
        <div class="navbar-collapse nav-side" id="navbarTogglerDemo01">
          <a class="navbar-brand" href=""><img src="branding/theme/assets/dynamic_assets/logo-lbg.png" alt="filmbox-logo"></a>
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item home-good-nav">
              {{configService.localeKeys?.['welcome.page5_title.text']}}
            </li>
          </ul>
          <form class="d-flex nav-form">
            <a class="nav-link signin-header" aria-current="page" [routerLink]="['/auth/signin']">{{configService.localeKeys?.['common_keys.sign_in.btn']}}</a>
            <button class="btn trial-btn" [routerLink]="['/auth/signup']">{{configService.localeKeys?.['plans.start_my_7day_trail.btn']}}</button>
          </form>
        </div>
      </div>
    </nav>
  }

</div>